import { onMount } from "svelte";
import { useEventDispatcher } from "./event-dispatcher.js";

/**
 *
 *
 *
 *
 *
 */
export const useMountEvents = (component: string, element: HTMLElement): void => {
  const dispatch = useEventDispatcher(element, false);
  const payload = { component, element };

  onMount(() => {
    dispatch(`${component}-mount`, payload, { cancelable: false, alias: ["oc-mount"] });

    return () => {
      dispatch(`${component}-unmount`, payload, { cancelable: false, alias: ["oc-unmount"] });
    };
  });
};
